import { render, staticRenderFns } from "./appAssetBreadcrumb.vue?vue&type=template&id=974a05a2&scoped=true"
import script from "./appAssetBreadcrumb.vue?vue&type=script&lang=js"
export * from "./appAssetBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./appAssetBreadcrumb.vue?vue&type=style&index=0&id=974a05a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "974a05a2",
  null
  
)

export default component.exports